const Actions = {
  cashout: {
    id: 1,
    name: 'payout',
    text: 'Repay to bank account',
    order: 1,
  },
  donate: {
    id: 2,
    name: 'donate',
    text: 'Donate to Calvert Impact Capital',
    order: 2,
  },
  reinvest: {
    id: 3,
    name: 'reinvest',
    text: 'Reinvest in a new Note',
    order: 0,
  },
};

export default Actions;



// WEBPACK FOOTER //
// ./src/data/static/upcomingTransactionActions.js